import forEach from 'lodash/forEach'
import isArray from 'lodash/isArray'

/**
 * Return message for HTTP status code
 * @param {number} status - HTTP status code
 * @returns {string} Message of network operation
 */
function _getStatusMessage(status) {
  let message = ''
  switch (status) {
    case 200:
      message = 'All done. Request successfully executed'
      break
    case 201:
      message = 'Data successfully created'
      break
    case 400:
      message = 'Bad Request'
      break
    case 401:
      message = 'Need auth'
      break
    case 404:
      message = 'Not found'
      break
    case 503:
      message = 'Service unavailable. Try again later'
      break
    default:
      message = 'Something wrong. Client default error message'
      break
  }
  return message
}

function _getResponseErrorMessage(error) {
  if (error.response && error.response.data) return error.response.data.message
  if (error.response && error.response.statusText) return error.response.statusText
  return error.message === 'Network Error' ? 'Oops! Network Error. Try again later' : error.message
}

/**
 * Create instance, which represent response object
 * @param {Object} [data] - custom data
 * @param {Object} [response] - axios response object
 * @param {String} [message] - custom message to display
 */
export class ResponseWrapper {
  constructor(response, data = {}, message) {
    this.data = data
    this.success = response.data.success
    this.status = response.data.statusCode
    this.statusMessage = _getStatusMessage(Number(this.status));
    this.message = message || response?.data?.message || null
  }
}


/**
 * Create instance, which represent error object
 * @param {Object} [error] - axios error object
 * @param {String} [message] - custom message to display
 */
export class ErrorWrapper extends Error {
  constructor(error, message) {
    super()
    this.success = error?.response ? error?.response?.data.success : false
    this.meta = error?.response ? error?.response?.data.meta : false
    this.code = error?.response ? error?.response?.data.code : false
    this.status = error?.response ? error?.response?.status : false
    this.statusMessage = _getStatusMessage(this.status)
    this.message = message || _getResponseErrorMessage(error)
    this.error = error.error
  }
}


/**
 * Uses to clear request data before send it
 * Client shouldn't change entity id
 * @param data
 * @return {{}}
 */
export function clearData(data) {
  const result = {}
  forEach(data, (item, propName) => {
    if (isArray(item) && item.length) {
      result[propName] = item
    }
    if (!isArray(item) && item && (propName !== 'id')) {
      result[propName] = item
    }
  })
  return result
}

// utils/errorHandler.js
export function handleError(response, fieldErrors, store) {
  if (Array.isArray(response?.response?.data?.error?.details)) {
    response?.response?.data?.error?.details.forEach((detail) => {
      const field = detail?.info?.missingProperty;
      const errorMessage = detail?.message || 'An error occurred';
      if (field && fieldErrors[field] === undefined) {
        fieldErrors[field] = errorMessage;
      }
    });
  } else {
    store.commit('toast/NEW', { type: 'error', message: response?.response?.data?.message || "Error Occured! Please Try Later!" });
  }
}

export const OBJECT_TYPES = {
  KIOSK: 'kiosk',
  PATIENT: 'patient',
  DOCTOR: 'doctor',
};

/**
 * Formats a name object into a readable string.
 * @param {Object} person - The object containing name details.
 * @param {string} person.firstname - The first name of the person.
 * @param {string} [person.lastname] - The last name of the person.
 * @param {string} [person.name] - The fallback full name if firstname and lastname are missing.
 * @returns {string} - The formatted name, e.g., "John D." or "John" or "Full Name".
 */
export function formatName(person) {
  if (!person) return "";

  if (person.firstname) {
    return person.lastname
      ? `${person.firstname} ${person.lastname[0]}.`
      : person.firstname;
  }

  return person.name || "";
}

export const faqs = [
  { id: 1, title: "How does the QR code scanning feature work?", description: "The QR code scanning feature allows users to quickly check in at kiosks at participating hospitals. Navigate to the QR code scanner in the mobile app, and scan the code displayed on the kiosk to check-in." },
  { id: 2, title: "What happens after I scan the QR code?", description: "After scanning, you will select a doctor and your check-in will be confirmed. You will receive updates in the Live Status page in the app. " },
  { id: 3, title: "Will the app remind me of my appointment before I visit?", description: "Yes, you’ll receive notifications and reminders leading up to your appointment time." },
  { id: 4, title: "How do I book an appointment through the app?", description: "Navigate to the Book Appointment section, select your preferred doctor, enter a reason for visiting, select three preferred dated, and submit your appointment request. Hospital staff will then assign a specific date and time to you which will be updated in the mobile app." }
 , { id: 5, title: "What if the QR code doesn’t work?", description: "If the QR code is not scanning, you can enter the code shown on the kiosk into the app. This alternate method also allows users to check-in." }
]